/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiUrl: 'https://homologacao.novo.renointeligencia.com/api/',
  apiOperacionalUrl: 'https://operacional.homologacao-api.renointeligencia.com/',
  apiExecutivoUrl: 'https://executivo.homologacao-api.renointeligencia.com/',
  siteUrl: 'https://homologacao.novo.renointeligencia.com',
  hubUrl: 'https://homologacao.novo.hub.renointeligencia.com',
  clarityProjectId: 'uy9utrdszw', // Staging/Homologação
  permitirTrocaAmbiente: true,
  ambientePadrao: 'Homologacao'
};
